// src/resources/Companies.js
import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  Edit,
  SimpleForm,
  TextInput,
  Create,
} from "react-admin";

/**
 * 🔹 Company List – shows all registered companies
 */
export const CompanyList = () => (
  <List title="Companies">
    <Datagrid>
      <TextField source="name" label="Company Name" />
      <EditButton />
    </Datagrid>
  </List>
);

/**
 * 🔹 Company Create – add new company
 */
export const CompanyCreate = () => (
  <Create title="Add Company">
    <SimpleForm>
      <TextInput source="name" label="Company Name" fullWidth required />
    </SimpleForm>
  </Create>
);

/**
 * 🔹 Company Edit – update existing company name
 */
export const CompanyEdit = () => (
  <Edit title="Edit Company">
    <SimpleForm>
      <TextInput source="name" label="Company Name" fullWidth required />
    </SimpleForm>
  </Edit>
);
